import React from 'react';
import { Layout } from 'antd';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PageHeader } from '~/Components/PageHeader';
import { Login, ForgotPassword, Register } from '../Login';
import { Main } from '../Main';
import { RegisterConfirmation } from '../Login/Register/RegisterConfirmation';
import { LeftMenu } from '~/Views/Main/LeftMenu';
import { UserSelectors } from '~/Store/User';

export const Root = () => {
  const authenticated = useSelector(UserSelectors.isAuthenticated);
  const location = useLocation();
  // These three routes render AuthLayout's own full-viewport shell (see Login/AuthLayout.tsx),
  // so the global header doesn't belong here. RegisterConfirmation keeps the regular app shell.
  const isFullScreenAuthRoute = ['/login', '/register', '/forgotpassword'].includes(location.pathname);

  return (
    <Layout style={{ height: '100vh' }}>
      {authenticated && <LeftMenu />}
      <Layout>
        {!isFullScreenAuthRoute && <PageHeader />}
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/registerconfirmation" component={RegisterConfirmation} />
          <Route exact path="/forgotpassword" component={ForgotPassword} />
          <Route path="/" component={Main} />
        </Switch>
      </Layout>
    </Layout>
  );
};
